import { useMemo } from 'react';

export default function useNavList({ basePath, currentProject, availableEndpoints }) {
    const navList = useMemo(() => {
        const baseNav = [
            {
                title: 'Материалы',
                sections: [
                    {
                        label: 'Основные',
                        icon: 'pen-alt',
                        items: [
                            {
                                href: `${basePath}/${currentProject}/story/news/all`,
                                label: 'Новости',
                                projects: ['media.vkplay.ru'],
                                endpoint: 'articles',
                            },
                            {
                                href: `${basePath}/${currentProject}/story/gof/all`,
                                label: 'Новости GoF',
                                projects: ['gof.vkplay.ru'],
                                endpoint: 'articles',
                            },
                            {
                                href: `${basePath}/${currentProject}/story/feat/all`,
                                label: 'Лонгриды',
                                projects: ['media.vkplay.ru'],
                                endpoint: 'articles',
                            },
                            {
                                href: `${basePath}/${currentProject}/story/review/all`,
                                label: 'Обзоры',
                                projects: ['media.vkplay.ru'],
                                endpoint: 'articles',
                            },
                            {
                                href: `${basePath}/${currentProject}/story/secret/all`,
                                label: 'Секреты',
                                projects: ['media.vkplay.ru'],
                                endpoint: 'articles',
                            },
                        ],
                    },
                    {
                        label: 'Дополнительные',
                        icon: 'newspaper',
                        items: [
                            {
                                href: `${basePath}/pockets/industry/${currentProject}/`,
                                label: 'Индустрия',
                                projects: ['media.vkplay.ru'],
                                endpoint: 'articles',
                            },
                            {
                                href: `${basePath}/${currentProject}/story/commercial/all`,
                                label: 'Коммерческие материалы',
                                projects: ['media.vkplay.ru'],
                                endpoint: 'articles',
                            },
                            {
                                href: `${basePath}/${currentProject}/story/static/all`,
                                label: 'Статичные материалы',
                                projects: ['gof.vkplay.ru'],
                                endpoint: 'articles',
                            },
                        ],
                    },
                ],
            },
            {
                title: 'Контент',
                sections: [
                    {
                        items: [
                            {
                                href: `${basePath}/video/`,
                                label: 'Видео',
                                projects: ['media.vkplay.ru'],
                                endpoint: 'videos',
                            },
                            {
                                href: `${basePath}/${currentProject}/story/file/all`,
                                label: 'Моды',
                                projects: ['media.vkplay.ru'],
                                endpoint: 'articles',
                            },
                            {
                                href: `${basePath}/betakeys/all`,
                                label: 'Бета-ключи',
                                projects: ['media.vkplay.ru'],
                                endpoint: 'betakeys',
                            },
                            {
                                href: `${basePath}/rawhtml/all`,
                                label: 'Raw HTML',
                                projects: ['media.vkplay.ru'],
                                endpoint: 'rawhtml',
                            },
                            {
                                href: `${basePath}/table/all`,
                                label: 'Таблицы',
                                projects: ['media.vkplay.ru'],
                                endpoint: 'tablehtml',
                            },
                            {
                                href: `${basePath}/quiz_trivia/all`,
                                label: 'Викторины',
                                projects: ['media.vkplay.ru'],
                                endpoint: 'articles',
                            },
                            {
                                href: `${basePath}/utility/file-storage`,
                                label: 'Хранилище файлов',
                                projects: ['media.vkplay.ru'],
                                endpoint: 'articles',
                            },
                        ],
                    },
                ],
            },
            {
                title: 'База игр',
                sections: [
                    {
                        items: [
                            {
                                href: `${basePath}/games/all`,
                                label: 'Игры',
                                projects: ['media.vkplay.ru'],
                                endpoint: 'games',
                            },
                            {
                                href: `${basePath}/${currentProject}/story/compilation/all`,
                                label: 'Подборки',
                                projects: ['media.vkplay.ru'],
                                endpoint: 'articles',
                            },
                            {
                                href: `${basePath}/pocket/popular-games/`,
                                label: 'Популярные игры',
                                projects: ['media.vkplay.ru'],
                                endpoint: 'games',
                            },
                            {
                                href: `${basePath}/pocket/best-games/`,
                                label: 'Лучшие игры',
                                projects: ['media.vkplay.ru'],
                                endpoint: 'games',
                            },
                            {
                                href: `${basePath}/tags/all`,
                                label: 'Теги',
                                projects: ['media.vkplay.ru'],
                                endpoint: 'games',
                            },
                        ],
                    },
                ],
            },
            {
                title: 'Внутренние списки',
                sections: [
                    {
                        label: 'Редакционные',
                        icon: 'feather-alt',
                        items: [
                            {
                                href: `${basePath}/pocket/breaking/${currentProject}`,
                                label: 'Перетяжка',
                                projects: ['media.vkplay.ru'],
                                endpoint: 'pockets',
                            },
                            {
                                href: `${basePath}/pocket/highlights-vkplay/`,
                                label: 'Хайлайты',
                                projects: ['media.vkplay.ru'],
                                endpoint: 'pockets',
                            },
                            {
                                href: `${basePath}/pocket/gof-countdown`,
                                label: 'Баннер обратного отсчёта',
                                projects: ['gof.vkplay.ru'],
                                endpoint: 'pockets',
                            },
                            {
                                href: `${basePath}/pocket/gof-featuring/ru`,
                                label: 'Карусель (ру)',
                                projects: ['gof.vkplay.ru'],
                                endpoint: 'pockets',
                            },
                            {
                                href: `${basePath}/pocket/gof-featuring/en`,
                                label: 'Карусель (en)',
                                projects: ['gof.vkplay.ru'],
                                endpoint: 'pockets',
                            },
                            {
                                href: `${basePath}/pocket/gof-streams`,
                                label: 'Трансляции',
                                projects: ['gof.vkplay.ru'],
                                endpoint: 'pockets',
                            },
                            {
                                href: `${basePath}/pocket/gof-tournaments`,
                                label: 'Календарь турниров',
                                projects: ['gof.vkplay.ru'],
                                endpoint: 'pockets',
                            },
                        ],
                    },
                    {
                        label: 'Коммерческие',
                        icon: 'money-bill',
                        items: [
                            {
                                href: `${basePath}/pocket/banner-right/${currentProject}/`,
                                label: 'Правый баннер',
                                projects: ['media.vkplay.ru'],
                                endpoint: 'pockets',
                            },
                            {
                                href: `${basePath}/pocket/commercial-desktop/${currentProject}/`,
                                label: 'Баннер в ленте (Десктоп)',
                                projects: ['media.vkplay.ru'],
                                endpoint: 'pockets',
                            },
                            {
                                href: `${basePath}/pocket/commercial-mobile/${currentProject}/`,
                                label: 'Баннер в ленте (Мобильный)',
                                projects: ['media.vkplay.ru'],
                                endpoint: 'pockets',
                            },
                        ],
                    },
                ],
            },
            {
                title: 'Внешние списки',
                sections: [
                    {
                        items: [
                            {
                                href: `${basePath}/pocket/main-mrg/`,
                                label: 'Главная Mail.ru',
                                projects: ['media.vkplay.ru'],
                                endpoint: 'pockets',
                            },
                            {
                                href: `${basePath}/pocket/main-gmr/`,
                                label: 'Главная GMR',
                                projects: ['media.vkplay.ru'],
                                endpoint: 'pockets',
                            },
                            {
                                href: `${basePath}/pocket/main-vkplay/`,
                                label: 'Главная VKP',
                                projects: ['media.vkplay.ru'],
                                endpoint: 'pockets',
                            },
                            {
                                href: `${basePath}/pocket/mailing_list_vkplay`,
                                label: 'Рассылки',
                                projects: ['media.vkplay.ru'],
                                endpoint: 'mail_vkplay',
                            },
                        ],
                    },
                ],
            },
            {
                title: 'Администрирование',
                sections: [
                    {
                        items: [
                            {
                                href: `${basePath}/authors/all`,
                                label: 'Авторы',
                                projects: ['media.vkplay.ru', 'gof.vkplay.ru'],
                                endpoint: 'admin',
                            },
                            {
                                href: `${basePath}/channels/all`,
                                label: 'Каналы',
                                projects: ['media.vkplay.ru', 'gof.vkplay.ru'],
                                endpoint: 'channels',
                            },
                            {
                                href: `${basePath}/admin/users/`,
                                label: 'Права доступа',
                                projects: ['media.vkplay.ru'],
                                endpoint: 'admin',
                            },
                            {
                                href: `${basePath}/canonical/all`,
                                label: 'Канонические страницы',
                                projects: ['media.vkplay.ru'],
                                endpoint: 'admin',
                            },
                            {
                                href: `${basePath}/reports/all`,
                                label: 'Отчёты',
                                projects: ['media.vkplay.ru'],
                                endpoint: 'report',
                            },
                            {
                                href: `${basePath}/hotbox/`,
                                label: 'Хотбокс',
                                projects: ['media.vkplay.ru', 'gof.vkplay.ru'],
                                endpoint: 'admin',
                            },
                        ],
                    },
                ],
            },
        ];

        const filteredNav = baseNav.filter(
            (category) => {
                category.sections = category.sections.filter(
                    (section) => {
                        section.items = section.items.filter(
                            (item) => {
                                if (!item.projects.includes(currentProject)) {
                                    return false;
                                }

                                if (item.endpoint && !availableEndpoints.includes(item.endpoint)) {
                                    return false;
                                }

                                return true;
                            },
                        );

                        return section.items.length ? section : false;
                    },
                );

                return category.sections.length ? category : false;
            },
        );

        return filteredNav;
    }, [basePath, currentProject, availableEndpoints]);

    return { navList };
}
